import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { leggiHapticsEnabled } from '@/lib/hapticsPreference';

interface SettingsState {
  hapticsEnabled: boolean;
  /**
   * Banner ridotto per liberare spazio verticale.
   *
   * NON persistito, e non piu' una preferenza: e' la conseguenza dello scroll.
   * Salvarlo significherebbe riaprire l'app in stato compresso senza che nulla
   * sia stato scrollato — uno stato senza causa visibile, che l'utente non
   * saprebbe come annullare ora che il comando manuale non c'e' piu'.
   */
  bannerCompact: boolean;
}

const initialState: SettingsState = {
  // Idratata da `localStorage` al caricamento del modulo, come `appearance.slice`: il primo render ha gia' la
  // scelta dell'utente. La scrittura sta in `store/index.ts` (un reducer non ha effetti collaterali).
  hapticsEnabled: leggiHapticsEnabled(),
  bannerCompact: false,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setHapticsEnabled(state, action: PayloadAction<boolean>) {
      state.hapticsEnabled = action.payload;
    },
    setBannerCompact(state, action: PayloadAction<boolean>) {
      state.bannerCompact = action.payload;
    },
  },
});

export const { setHapticsEnabled, setBannerCompact } = settingsSlice.actions;
export default settingsSlice.reducer;
